import { ReactNode, useCallback, useEffect, useState } from "react";

import { BrazeAPIKey, BrazeCustomEndpoint, BrazeEnableLogging } from "config/constants";
import { useAppSelector } from "store";
import { getUser } from "store/selectors";

import { changeUser, getUser as getBrazeUser, initialize, openSession } from "@braze/web-sdk";

import { BrazeIAMProvider } from "./BrazeIAMProvider";

interface IBrazeProvider {
  children: ReactNode;
}

function BrazeProvider({ children }: IBrazeProvider) {
  const user = useAppSelector(getUser);

  const [isInitialized, setIsInitialized] = useState(false);
  const initializeBraze = useCallback(async () => {
    const hasSuccessfullyInitialized = await initialize(BrazeAPIKey, {
      baseUrl: BrazeCustomEndpoint,
      enableLogging: !!BrazeEnableLogging,
      allowUserSuppliedJavascript: true,
    });

    if (hasSuccessfullyInitialized) {
      await openSession();
      setIsInitialized(hasSuccessfullyInitialized);
    }
    return hasSuccessfullyInitialized;
  }, []);

  useEffect(() => {
    async function init() {
      await initializeBraze();
    }
    init();
  }, [initializeBraze]);

  useEffect(() => {
    if (isInitialized) {
      const brazeUserId = getBrazeUser()?.getUserId();
      if (user && user.id !== brazeUserId) {
        changeUser(user.id);
      }
    }
  }, [isInitialized, user]);

  return (
    <>
      {isInitialized && <BrazeIAMProvider />}
      {children}
    </>
  );
}

export default BrazeProvider;
